import { JobState, JobType, } from '@models';
import { compareObjects, getProperty, } from '@utils/object.utils';
import { isBool, isJson, } from '@utils/string.utils';
import cloneDeep from 'lodash-es/cloneDeep';
import isArray from 'lodash-es/isArray';
import values from 'lodash-es/values';
import * as moment from 'moment';
var propertyExclusions = {
    'Environments': {
        'Update': {
            properties: {
                'UiEnvironment': ['Robots'],
            },
        },
    },
    'Robots': {
        'Create': {
            objects: ['UiSession', 'UiUserOrganizationUnitRole'],
        },
        'Delete': {
            objects: ['UiSession', 'UiUserOrganizationUnitRole'],
        },
    },
    'Users': {
        'All': {
            properties: {
                'UserRole': ['UserName'],
            },
        },
        'Update': {
            properties: {
                'UserOrganizationUnit': ['UserName'],
            },
        },
    },
    'Roles': {
        'Associate': {
            objects: ['UiUser'],
        },
        'All': {
            properties: {
                'UserRole': ['RoleName'],
                'RolePermissionSetting': ['IsGranted'],
            },
        },
    },
    'Jobs': {
        'All': {
            objects: ['JobBatchInfo'],
        },
        'StopJob': {
            properties: {
                'UiJob': ['Key', 'State', 'BatchExecutionKey'],
            },
        },
    },
    'Tenant': {
        'All': {
            properties: {
                'RolePermissionSetting': ['IsGranted'],
            },
        },
    },
    'Units': {
        'Associate': {
            properties: {
                'UserOrganizationUnit': ['OrganizationUnitName'],
            },
        },
    },
};
var idListExceptions = ['TimeZoneId', 'CredentialStoreId', 'OrganizationUnitId'];
var formatStopAfter = function (stopAfter) {
    return moment().add(stopAfter, 'seconds').fromNow(true);
};
var ɵ0 = formatStopAfter;
export var cleanupAssetTypeProperties = function (data, type, model) {
    if (type === void 0) { type = 'All'; }
    if (model === void 0) { model = 'Global'; }
    switch (type) {
        case 'Bool':
            delete data.StringValue;
            delete data.IntValue;
            delete data.CredentialUsername;
            delete data.ExternalName;
            break;
        case 'Text':
            delete data.BoolValue;
            delete data.IntValue;
            delete data.CredentialUsername;
            delete data.ExternalName;
            break;
        case 'Integer':
            delete data.StringValue;
            delete data.BoolValue;
            delete data.CredentialUsername;
            delete data.ExternalName;
            break;
        case 'Credential':
            delete data.StringValue;
            delete data.IntValue;
            delete data.BoolValue;
            break;
        default:
            delete data.StringValue;
            delete data.IntValue;
            delete data.BoolValue;
            delete data.CredentialUsername;
            delete data.ExternalName;
    }
    if (model === 'Robot') {
        delete data.ValueType;
        var robotName = data['RobotName'];
        delete data.RobotName;
        var valueKey = Object.keys(data)[0];
        data[robotName] = data[valueKey];
        delete data[valueKey];
    }
};
var containsValue = function (data) {
    return data.hasDefaultValue;
};
var ɵ1 = containsValue;
export var filterAssetResponse = function (entry, data) {
    if (entry.entityName === 'UiAsset') {
        if (data.Values.ValueScope === 'Global') {
            cleanupAssetTypeProperties(data.Values, data.Values.ValueType);
        }
        else if (data.Values.ValueScope === 'PerRobot') {
            if (containsValue(data.Values)) {
                cleanupAssetTypeProperties(data.Values, data.Values.ValueType);
            }
            else {
                cleanupAssetTypeProperties(data.Values);
            }
            for (var _i = 0, _a = data.Values.RobotValues; _i < _a.length; _i++) {
                var robotValue = _a[_i];
                cleanupAssetTypeProperties(robotValue, data.Values.ValueType, 'Robot');
            }
        }
        if (entry.action === 'Update') {
            if (data.OldValues.ValueScope === 'Global') {
                cleanupAssetTypeProperties(data.OldValues, data.OldValues.ValueType);
            }
            else if (data.OldValues.ValueScope === 'PerRobot') {
                if (containsValue(data.OldValues)) {
                    cleanupAssetTypeProperties(data.OldValues, data.OldValues.ValueType);
                }
                else {
                    cleanupAssetTypeProperties(data.OldValues);
                }
            }
            for (var _b = 0, _c = data.OldValues.RobotValues; _b < _c.length; _b++) {
                var robotValue = _c[_b];
                cleanupAssetTypeProperties(robotValue, data.OldValues.ValueType, 'Robot');
            }
        }
    }
};
export var flattenDynamicProperties = function (entry) {
    if (!entry) {
        return;
    }
    for (var _i = 0, _a = Object.keys(entry); _i < _a.length; _i++) {
        var key = _a[_i];
        if (entry[key].hasOwnProperty('DynamicProperties')) {
            entry[key] = entry[key]['DynamicProperties'];
        }
    }
};
export var flattenSinglePropertyArrays = function (entry) {
    if (!entry) {
        return;
    }
    var _loop_1 = function (key) {
        if (isArray(entry[key]) && entry[key].length > 0) {
            if (entry.RobotValues && entry.RobotValues.length > 0) {
                return "continue";
            }
            var keys_1 = Object.keys(entry[key][0]);
            if (keys_1.length === 1) {
                entry[key] = entry[key].map(function (item) { return item[keys_1[0]]; });
            }
        }
    };
    for (var _i = 0, _a = Object.keys(entry); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
};
export var filterIdAndKeyProperties = function (object) {
    for (var property in object) {
        if (!object.hasOwnProperty(property)) {
            continue;
        }
        if (object[property] instanceof Object) {
            object[property] = filterIdAndKeyProperties(object[property]);
        }
        else if (!idListExceptions.includes(property) &&
            property.endsWith('Id') ||
            property.endsWith('Key')) {
            // the id property should not be displayed
            delete object[property];
        }
    }
    return object;
};
var flattenSettingValue = function (settings) {
    if (settings &&
        !isBool(settings.Value) &&
        isJson(settings.Value)) {
        settings.Value = JSON.parse(settings.Value);
        delete settings.Value.RegexComplexity;
        Object.assign(settings, settings.Value);
        delete settings.Value;
    }
};
var ɵ2 = flattenSettingValue;
export var mapSettings = function (entry, data, settingsMap) {
    if (entry.entityName === 'Setting') {
        if (entry.action === 'Create') {
            data['OldValues'] = cloneDeep(data.Values);
            data.OldValues.Value = '*Host Setting*';
            entry.action = 'Update';
        }
        else if (entry.action === 'Delete') {
            data['OldValues'] = cloneDeep(data.Values);
            data.Values.Value = '*Host Setting*';
            entry.action = 'Update';
        }
        // rewrite the names
        if (data['Values'] && data['Values']['Name'] && settingsMap[data.Values.Name]) {
            data['Values']['Name'] = settingsMap[data.Values.Name];
            entry.entityName = data['Values']['Name'];
            delete data.Values['Name'];
        }
        if (data['OldValues'] && data['OldValues']['Name'] && settingsMap[data.OldValues.Name]) {
            data['OldValues']['Name'] = settingsMap[data.OldValues.Name];
            entry.entityName = data['OldValues']['Name'];
            delete data.OldValues['Name'];
        }
        flattenSettingValue(data.Values);
        flattenSettingValue(data.OldValues);
    }
};
export var mapJobs = function (entry, jobValues) {
    if (entry.entityName === 'UiJob') {
        var robot = jobValues && getProperty(jobValues, 'Robot');
        if (robot) {
            jobValues['Robot'] = robot['Name'];
        }
        if (jobValues) {
            if (jobValues['Type'] != null) {
                jobValues['Type'] = JobType[jobValues['Type']];
            }
            if (jobValues['State'] != null) {
                jobValues['State'] = JobState[jobValues['State']];
            }
        }
        ['InputArguments', 'OutputArguments'].forEach(function (key) {
            if (jobValues &&
                jobValues[key] != null) {
                try {
                    jobValues[key] = JSON.parse(jobValues[key]);
                }
                catch (_a) {
                    jobValues[key] = jobValues[key];
                }
            }
        });
    }
};
export var mapProcesses = function (entry, processValues) {
    if (entry.entityName === 'UiRelease') {
        var key = 'InputArguments';
        if (processValues &&
            processValues[key] != null) {
            try {
                processValues[key] = JSON.parse(processValues[key]);
            }
            catch (_a) {
                processValues[key] = processValues[key];
            }
        }
    }
};
export var mapPackages = function (entry, packageValues) {
    if (entry.entityName !== 'UiPackageVersion' ||
        !packageValues ||
        !packageValues['Arguments']) {
        return;
    }
    ['Input', 'Output'].forEach(function (key) {
        if (packageValues.Arguments[key] != null) {
            try {
                packageValues.Arguments[key] = JSON.parse(packageValues.Arguments[key]);
            }
            catch (_a) {
                packageValues.Arguments[key] = packageValues.Arguments[key];
            }
        }
    });
};
export var mapTriggers = function (entry, triggerValues) {
    if (entry.entityName !== 'UiProcessSchedule' || !triggerValues) {
        return;
    }
    triggerValues['TimeZone'] = triggerValues['TimeZoneId'];
    delete triggerValues['TimeZoneId'];
    delete triggerValues['TimeZoneIana'];
    ['InputArguments', 'OutputArguments'].forEach(function (key) {
        if (triggerValues[key] != null) {
            try {
                triggerValues[key] = JSON.parse(triggerValues[key]);
            }
            catch (_a) {
                triggerValues[key] = triggerValues[key];
            }
        }
    });
    if (triggerValues['StopProcessExpression'] != null && triggerValues['StopProcessExpression'] !== '') {
        triggerValues['__StopProcessExpression'] = moment
            .localeData()
            .relativeTime(triggerValues['StopProcessExpression'], true, 'ss', false);
        triggerValues['StopProcessExpression'] = {
            translate: {
                key: 'global_after_time',
                data: {
                    timeDelta: formatStopAfter(triggerValues['StopProcessExpression']),
                },
            },
        };
    }
};
export var excludeFor = function (component, action, logDetail) {
    var obj = cloneDeep(logDetail);
    if (propertyExclusions[component] &&
        propertyExclusions[component][action]) {
        var excludedProperties = propertyExclusions[component][action];
        if (excludedProperties.objects &&
            excludedProperties.objects.includes(obj.entityName)) {
            obj.data.value = {};
            obj.data.oldValue = {};
        }
        if (excludedProperties.properties &&
            excludedProperties.properties[obj.entityName]) {
            for (var _i = 0, _a = Object.keys(obj.data.value); _i < _a.length; _i++) {
                var key = _a[_i];
                if (excludedProperties.properties[obj.entityName].includes(key)) {
                    delete obj.data.value[key];
                }
            }
        }
    }
    return obj;
};
export var differenceMap = function (current, previous, keys) {
    var map = {};
    for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
        var key = keys_2[_i];
        var currentValue = current[key];
        var oldValue = previous[key];
        map[key] = !compareObjects(currentValue, oldValue);
    }
    return map;
};
export var filterProperties = function (current, previous) {
    for (var property in current) {
        if (!current.hasOwnProperty(property)) {
            continue;
        }
        var oldValue = current[property];
        if (oldValue == null || (oldValue instanceof Array && oldValue.length === 0)) {
            // if a previously null-like value has been updated, keep property
            var newValue = previous && previous[property];
            var isValueArray = newValue instanceof Array;
            var isArrayPopulated = isValueArray && newValue.length > 0;
            var isPropertyPopulated = !isValueArray && newValue != null && newValue !== '';
            if (isArrayPopulated || isPropertyPopulated) {
                continue;
            }
            delete current[property];
        }
    }
    return {
        current: current,
        previous: previous,
    };
};
export var groupComponents = function (changes) {
    var deleteIndexes = [];
    var components = {};
    var actionMap = {
        Create: 'Added',
        Delete: 'Removed',
    };
    changes.forEach(function (component, index) {
        if (component.isUpdate ||
            component.keys.length !== 1 ||
            !['Create', 'Delete'].includes(component.action)) {
            return;
        }
        components[component.entityName] = components[component.entityName] || {
            entityName: component.entityName,
            Added: [],
            Removed: [],
        };
        // get the object inside and store it
        var value = component.current[component.keys[0]];
        components[component.entityName][actionMap[component.action]].push(value);
        deleteIndexes.push(index);
    });
    // remove the reference
    var oldLength = changes.length;
    deleteIndexes.forEach(function (index) { return changes.splice(index - (oldLength - changes.length), 1); });
    for (var _i = 0, _a = Object.keys(components); _i < _a.length; _i++) {
        var key = _a[_i];
        var component = components[key];
        var change = {
            title: component.entityName,
            keys: [],
            current: {},
            differenceMap: {},
        };
        if (component.Added.length) {
            change.keys.push('Added');
            change.current['Added'] = component.Added;
        }
        if (component.Removed.length) {
            change.keys.push('Removed');
            change.current['Removed'] = component.Removed;
        }
        changes.push(change);
    }
    return changes;
};
export var getTitleFor = function (log, entity) {
    switch (log.component) {
        case 'Jobs':
            switch (log.action) {
                case 'StopJob':
                    return "Job " + entity.data.value.ReleaseName;
            }
            break;
        default:
            return entity.action + " " + entity.entityName.replace(/^Ui/, '');
    }
};
export var isEmptyObject = function (obj) {
    return typeof obj === 'object' && !Object.keys(obj).length;
};
export var extractChanges = function (logDetails, log) {
    var changes = [];
    logDetails.forEach(function (detail) {
        var _a = filterProperties(detail.data.value, detail.data.oldValue), current = _a.current, previous = _a.previous;
        var change = {
            action: detail.action,
            entityName: detail.entityName.replace(/^Ui/, ''),
            title: getTitleFor(log, detail),
            differenceMap: {},
            isUpdate: !!detail.data.oldValue && !isEmptyObject(detail.data.oldValue),
            current: current,
            previous: previous,
            keys: Array.from(new Set(Object.keys(current).concat(Object.keys(previous || {})))),
        };
        if (change.isUpdate) {
            change.differenceMap = differenceMap(change.current, change.previous, change.keys);
        }
        // if the update has no changes, show the current data
        var hasAtLeastOneChange = values(change.differenceMap).reduce(function (prev, curr) { return prev || curr; }, false);
        if (change.isUpdate && !hasAtLeastOneChange) {
            change.previous = {};
            change.isUpdate = false;
        }
        changes.push(change);
    });
    return groupComponents(changes);
};
export { ɵ0, ɵ1, ɵ2 };
